import mitt from 'mitt';
import { reactive } from 'vue';

import { useDeliveryTermsStorage } from '@/composables/useDeliveryTermsStorage';

export default {
  install: (app, options) => {
    const cityData = reactive({
      isConfirmationNeeded: false,
      isCityHeaderShown: false, // изм. города в хэдере
      isCityModalShown: false, // изм. города в модалке
      isCityConfirmationShown: false,
      microCities: [],
    });
    // eslint-disable-next-line no-param-reassign
    app.config.globalProperties.$city = {
      data: cityData,

      emmiter: mitt(),

      changeCity() { // данный метод управляет ТОЛЬКО модалкой/мобилкой смены города
        return new Promise((resolve, reject) => {
          if (options?.adaptive.isDesktop) {
            cityData.isCityModalShown = true;
          } else {
            app.config.globalProperties.$nav.show('selectCity');
          }

          this.emmiter.on('city', (city) => {
            if (options?.adaptive.isDesktop) {
              cityData.isCityModalShown = false;
            } else {
              app.config.globalProperties.$nav.hide();
            }

            this.emmiter.off('city');
            this.emmiter.off('city:close');
            resolve(city);
          });

          this.emmiter.on('city:close', () => {
            if (options?.adaptive.isDesktop) {
              cityData.isCityModalShown = false;
            } else {
              app.config.globalProperties.$nav.hide();
            }

            this.emmiter.off('city');
            this.emmiter.off('city:close');
            reject();
          });
        });
      },

      showCityConfirmation() { // отркыть модалку подтверждения смены макрогорода
        cityData.isCityConfirmationShown = true;

        return new Promise((resolve) => {
          this.emmiter.on('city-confirmation', (answer) => {
            this.emmiter.off('city-confirmation');
            resolve(answer);
          });
        });
      },

      hideCityConfirmation() { // закрыть модалку подтверждения смены макрогорода
        cityData.isCityConfirmationShown = false;
        cityData.isCityHeaderShown = false;
        this.emmiter.off('city-confirmation');
      },

      async loadMicroCities(cityId) { // загрузка макрогородов
        cityData.microCities = await options.store.$api.loadMicroCities({ cityId });
      },

      requestConfirmation({ city, reloadPage = false }) { // запрос смены города с подтверждением
        const { fetchDeliveryTerms } = useDeliveryTermsStorage(options.store);
        const updateCity = (currentCity) => options.store.dispatch('user/updateCity', currentCity).then(
          async () => {
            await fetchDeliveryTerms({ forceUpdate: true });

            if (reloadPage) {
              // перезагрузка страницы + удаление GET параметров
              const { origin, pathname } = window.location;
              window.location.assign(`${origin}${pathname}`);
            } else {
              this.hideCityConfirmation();
            }
          },
        );

        if (this.checkConfirmation(city)) {
          return this.showCityConfirmation().then((answer) => {
            if (answer) {
              updateCity(city);
            } else {
              this.hideCityConfirmation();
            }

            return answer;
          });
        }
        return updateCity(city);
      },

      checkConfirmation(city) { // проверяем необходимость подтверждения смены города
        // eslint-disable-next-line no-return-assign
        return cityData.isConfirmationNeeded = !cityData.microCities.filter((c) => c.id === city.id).length;
      },
    };
  },
};
